import gsap from 'gsap'
class Tooltip{
	constructor() {
		this.sieges = document.querySelectorAll('.siege')
		this.tooltip = document.querySelectorAll('.siege-tooltip')
		this.init()
	}

	init(){
		this.displaySiege()
	}

	displaySiege(){
		//console.log(this.sieges)
		//console.log(this.tooltip)
		this.sieges.forEach((el,i)=>{
			el.addEventListener('mouseenter',(e)=>{
				this.tooltip[i].style.opacity = 1
			})
			el.addEventListener('mouseleave',(e)=>{
				this.tooltip[i].style.opacity = 0
			})
		})
	}
}

module.exports = Tooltip
